/**
 * @generated SignedSource<<e5e64edbc030bc3e8a78f92d34ff283c>>
 * @relayHash 02deebd8d86b1defd7fbebab413d7b19
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 02deebd8d86b1defd7fbebab413d7b19

import { ConcreteRequest } from 'relay-runtime';
export type ChMedicationType = "FREE_TEXT_MEDICATION" | "PREPARATION" | "SUBSTANCE" | "TEMPLATE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type MedicationUnit = "GTT" | "IU" | "MG" | "ML" | "PC" | "PRN" | "PUFF";
export type useChMedicationSearchItemQueryTemplateQuery$variables = {
  patientLanguage: Language;
  templateId: number;
};
export type useChMedicationSearchItemQueryTemplateQuery$data = {
  readonly ch_medicationTemplateSearchItem: {
    readonly articles: ReadonlyArray<{
      readonly description: string;
      readonly globalTradeItemNumber: string | null;
      readonly pharmacode: number | null;
      readonly publicPrice: number | null;
    }>;
    readonly atcCode: string | null;
    readonly category: string | null;
    readonly description: string;
    readonly eveningDosage: number | null;
    readonly hasNews: boolean;
    readonly isGeneric: boolean;
    readonly medicationType: ChMedicationType;
    readonly morningDosage: number | null;
    readonly nightDosage: number | null;
    readonly noonDosage: number | null;
    readonly productUrl: any | null;
    readonly therapyDurationDays: number | null;
    readonly unit: MedicationUnit | null;
    readonly usageInstructions: string;
  } | null;
};
export type useChMedicationSearchItemQueryTemplateQuery = {
  response: useChMedicationSearchItemQueryTemplateQuery$data;
  variables: useChMedicationSearchItemQueryTemplateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientLanguage"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "patientLanguage",
        "variableName": "patientLanguage"
      },
      {
        "kind": "Variable",
        "name": "templateId",
        "variableName": "templateId"
      }
    ],
    "concreteType": "MedicationSearchItem",
    "kind": "LinkedField",
    "name": "ch_medicationTemplateSearchItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNews",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MedicationSearchItemArticle",
        "kind": "LinkedField",
        "name": "articles",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "globalTradeItemNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pharmacode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicPrice",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "category",
        "storageKey": null
      },
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eveningDosage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "medicationType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "morningDosage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nightDosage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "therapyDurationDays",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "noonDosage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "usageInstructions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "atcCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isGeneric",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChMedicationSearchItemQueryTemplateQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChMedicationSearchItemQueryTemplateQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "02deebd8d86b1defd7fbebab413d7b19",
    "metadata": {},
    "name": "useChMedicationSearchItemQueryTemplateQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2339d3ee4e981975a9f5d0bdc0ad485d";

export default node;
